import { z } from 'zod'
import { v4 as uuidv4 } from 'uuid'

/**
 * Représentation d'un identifiant d'utilisateur au format UUID v4
 */
export const UserIdentifierSchema = z.string().uuid().default(uuidv4)
export type UserIdentifierEntity = z.infer<typeof UserIdentifierSchema>